import { SVGFC } from '@repo/toolkit/types'

const EyeCloseIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.8793 11.8562C21.7095 11.617 17.6652 6 12.4999 6C7.33461 6 3.29012 11.617 3.12057 11.856C2.95981 12.0828 2.95981 12.3906 3.12057 12.6175C3.29012 12.8567 7.33461 18.4737 12.4999 18.4737C17.6652 18.4737 21.7095 12.8566 21.8793 12.6177C22.0402 12.3908 22.0402 12.0828 21.8793 11.8562ZM12.4999 17.1833C8.69512 17.1833 5.39976 13.4552 4.42426 12.2364C5.3985 11.0165 8.68695 7.29037 12.4999 7.29037C16.3045 7.29037 19.5997 11.0178 20.5756 12.2373C19.6013 13.4571 16.3129 17.1833 12.4999 17.1833Z"
        fill={color}
      />
      <path
        d="M12.5005 8.37012C10.4282 8.37012 8.74219 10.1068 8.74219 12.2413C8.74219 14.3758 10.4282 16.1124 12.5005 16.1124C14.5727 16.1124 16.2587 14.3758 16.2587 12.2413C16.2587 10.1068 14.5727 8.37012 12.5005 8.37012ZM12.5005 14.822C11.1189 14.822 9.99497 13.6643 9.99497 12.2413C9.99497 10.8182 11.1189 9.66053 12.5005 9.66053C13.882 9.66053 15.0059 10.8182 15.0059 12.2413C15.0059 13.6643 13.882 14.822 12.5005 14.822Z"
        fill={color}
      />
      <rect
        x="-0.0547429"
        y="-0.494008"
        width="1.72947"
        height="20.1208"
        rx="0.864736"
        transform="matrix(0.771585 0.636127 -0.613592 0.789623 17.6053 3.9309)"
        fill={color}
        stroke={color}
        strokeWidth="0.69298"
      />
    </svg>
  )
}

export default EyeCloseIcon
